/**
 * Maps app paths to browser tab titles (without the " | Club 4X4" suffix).
 */
export function getPageTitleForPath(pathname: string): string | undefined {
  if (pathname === '/') return 'Manage your policy'
  if (pathname === '/signin') return 'Sign in'
  if (pathname === '/register') return 'Create account'
  if (pathname === '/confirm-details') return 'Confirm your details'
  if (pathname === '/confirm-details/verify') return 'Verify your email'
  if (pathname === '/mfa/mobile-required') return 'Update your mobile number'
  if (pathname === '/mfa/verify') return 'Verify with a text message'
  if (pathname === '/check-your-details') return 'Check your details'
  if (pathname === '/match-found') return 'Match found'
  if (pathname === '/dashboard') return 'Dashboard'
  if (pathname === '/claims') return 'Claims'
  if (pathname.startsWith('/claims/')) return 'Make a claim'
  if (pathname === '/help/faq') return 'Help and FAQ'
  if (pathname.startsWith('/documents/')) return 'Policy documents'
  if (pathname.includes('/change-method')) return 'Change payment method'
  if (pathname.startsWith('/payment/')) return 'Payment'
  if (pathname.includes('/update-confirmed')) return 'Policy updated'
  if (pathname.includes('/update-all')) return 'Update policy'
  if (pathname.includes('/edit-driver')) return 'Update listed driver'
  if (pathname.includes('/update-listed-drivers')) return 'Listed drivers'
  if (pathname.startsWith('/policy/')) return 'Policy'
  return undefined
}
